import { TEnvironment } from './environment.type';

type Args = {
  servicesDomain: string;
  webpageDomain: string;
  backendDomain: string;
};

export function EnvironmentFactory({
  backendDomain,
  servicesDomain,
  webpageDomain,
}: Args): TEnvironment {
  return {
    base: '/',
    backend: {
      root: backendDomain,
    },
    adminCores: {
      backendURL: `${backendDomain}`,
      basePath: `/admin`,
      servicesURL: `${servicesDomain}/admin`,
      backend: {
        auth: `${backendDomain}/auth`,
      },
      services: {
        account: `${servicesDomain}/account`,
        root: `${servicesDomain}/root`,
      },
    },
    biz: {
      signInURL: `${webpageDomain}/auth/admin`,
      mainBackendURL: `${servicesDomain}/main`,
      cartaBackendURL: `${servicesDomain}/admin-carta`,
      backend: {
        auth: `${backendDomain}/auth`,
      },
      cores: {
        root: {
          path: servicesDomain + `${servicesDomain}/biz/root`,
          backendURL: `${servicesDomain}/main`,
        },
        monitor: {
          backend: {
            auth: backendDomain,
          },
          paths: {
            base: '/biz/monitor',
            auth: '/auth/admin',
          },
          services: {
            monitor: `${servicesDomain}/monitor`,
          },
        },
      },
    },
    routes: {
      adminCores: true,
      biz: true,
      auth: true,
      client: true,
      mina: true,
      session: true,
    },

    cores: {
      account: {
        backend: {
          auth: `${backendDomain}/auth`,
          root: backendDomain,
        },
        paths: {
          account: `${webpageDomain}/account`,
          mina: `${webpageDomain}/mina`,
        },
        services: {
          account: `${servicesDomain}/account`,
          main: `${servicesDomain}/main`,
        },
      },
      auth: {
        backendServicesURL: `${servicesDomain}/auth`,
        mainBackendURL: `${servicesDomain}/main`,
        adminWebURL: `${webpageDomain}/auth`,
        backend: `${backendDomain}/auth`,
        services: {
          auth: `${servicesDomain}/auth`,
          main: `${servicesDomain}/main`,
          root: `${servicesDomain}/root`,
        },
        paths: {
          account: `${webpageDomain}/accounts`,
          mina: `${webpageDomain}/mina`,
          root: `${webpageDomain}/auth`,
        },
      },
    },

    production: false,
    account: {
      services: `${servicesDomain}/account`,
    },
    sessionPageURL: `${webpageDomain}/account/session`,
    sessionServiceURL: `${servicesDomain}/session`,
    httpDelay: {
      min: 500,
      max: 3000,
    },
    apps: {
      account: {
        services: `${servicesDomain}/account`,
      },
      auth: {
        backend: `${backendDomain}/auth`,
        servicesURL: `${servicesDomain}/auth`,
        paths: {
          account: `${webpageDomain}/accounts`,
        },
      },
      qline: {
        services: `${servicesDomain}/qline`,
      },
    },
    client: {
      authURL: `${webpageDomain}/auth`,
    },
    journal: {
      services: `${servicesDomain}/journal`,
      userServices: `${servicesDomain}/user`,
      authWeb: `${servicesDomain}/auth`,
      httpDelay: {
        min: 500,
        max: 3000,
      },
    },
    mina: {
      backendURL: `${backendDomain}`,
      basePath: `/mina`,
      servicesURL: `${servicesDomain}/mina`,
      clientWebStore: {
        signInURL: `${webpageDomain}/auth`,
        backendURL: `${backendDomain}`,
      },
      backend: {
        auth: `${backendDomain}/auth`,
      },
      paths: {
        account: `${webpageDomain}/account`,
        auth: `${webpageDomain}/auth`,
        root: `${webpageDomain}`,
      },
      services: {
        main: `${servicesDomain}/main`,
        root: `${servicesDomain}/root`,
      },
    },
  };
}
